import { motion } from "framer-motion";
import { EASE } from "@/lib/site";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ y, opacity: 0.55 }}
    whileInView={{ y: 0, opacity: 1 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <p className={`font-mono-x text-xs uppercase tracking-[0.25em] text-[#ff8a3d] ${className}`}>{children}</p>
);

export const SectionTitle = ({ children, className = "" }) => (
  <h2 className={`font-display text-5xl font-black uppercase leading-[0.9] tracking-tight sm:text-6xl lg:text-7xl ${className}`}>
    {children}
  </h2>
);
